import { useState, useEffect } from "react";
import useFormData from "hooks/useFormData";
import ResultsLayout from "../ResultsLayout";

export default function Module({ Component, results_props = {} }) {

   const { data: params, errors, setErrors, onDataChange } = useFormData();
   const [ show_results, setShowResults ] = useState( false );
   const [ url_mode, setUrlMode ] = useState( null );
   const [ url_colors, setUrlColors ] = useState( null );
   
   const onBackToSteps = () => {
      // Resetuj zmienne związane z wyborem zmiennych (ale zachowaj edition)
      const resetParams = {
         key_variable_ids: undefined,
         key_variable_id: undefined,
         grouping_variable_ids: undefined,
         filters: undefined
      };
      onDataChange(resetParams);
      setShowResults( false );
   };

   useEffect(() => {

      const search_params = new URLSearchParams( window.location.search );
      if ( !search_params.toString()) return;

      const params = {};
      search_params.forEach(( s, key ) => {
         if ([ "filters" ].includes( key )) {
            try {
               params[ key ] = JSON.parse( s );
            } catch {}
         } else if ([
            "years",
            "profession_ids",
            "voivodeship_ids",
            "key_variable_ids",
            "grouping_variable_ids"
         ].includes( key )) {
            params[ key ] = s.split(",").map( p => Number( p ));
         } else if ([ "edition", "edition2", "compare_mode" ].includes( key )) {
            // edition, edition2 i compare_mode powinny pozostać jako string
            params[ key ] = s;
         } else params[ key ] = isNaN( Number( s )) ? s : Number( s );
      });

      if (params.mode) {
         setUrlMode( params.mode );
         delete params.mode;
      }

      if (params.colors && typeof params.colors === "string") {
         setUrlColors(params.colors.split(",").map(c => "#" + c));
         delete params.colors;
      }

      onDataChange( params );
      setShowResults( true );
   }, [])

   return show_results
      ? (
         <ResultsLayout 
            init_params={ params }
            onBackToSteps={ onBackToSteps }
            {...results_props }
            {...( url_mode ? { init_mode: url_mode } : {} )}
            {...( url_colors ? { init_colors: url_colors } : {} )}
         />
      ) : (
         <Component
            params={ params }
            errors={ errors }
            setErrors={ setErrors }
            onChange={ onDataChange }
            onSubmit={() => {
               setShowResults( true );
            }}
         />
      )
}